// extracted by mini-css-extract-plugin
module.exports = {"ScreenNotification":"ScreenNotification__1M2s_"};